<template>
    <div>
        <v-card-title class="d-flex align-center justify-space-between">
            <div class="font-weight-bold">{{ title }}</div>

            <v-btn class="d-flex justify-end" variant="plain" :ripple="false" @click="$emit('close-clicked')">
                <font-awesome-icon :icon="['fas', 'x']" />
            </v-btn>
        </v-card-title>

        <v-divider />
    </div>
</template>

<script>
export default {
    name: "ModalHeader",
    emit: [ 'close-clicked' ],
    props: {
        title: {
            required: false,
            default: ''
        }
    }
}
</script>

<style scoped>

</style>
